import { LoadingLineItem } from '@app/components/LineItem';
import Box from '@redbubble/design-system/src/Box';
import Divider from '@redbubble/design-system/src/Divider';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { Fragment } from 'react';
import styles from './LineItemsList.module.scss';

const NUM_LOADING_ITEMS = 3;

export const messages = defineMessages({
  ariaLabelText: {
    defaultMessage: 'Line items in cart',
  },
  ariaLabelTextLoading: {
    defaultMessage: 'Loading line items in cart',
  },
});

interface LineItemsListProps {
  children?: JSX.Element[];
  loading?: boolean;
  narrow?: boolean;
}

export const LineItemsList: React.FC<LineItemsListProps> = ({
  children,
  loading,
  narrow,
}) => {
  const intl = useIntl();
  const listClassName = [styles.wrapper, narrow && styles.narrow]
    .filter(Boolean)
    .join(' ');

  if (loading) {
    return (
      <Box
        element="ul"
        className={listClassName}
        aria-label={intl.formatMessage(messages.ariaLabelTextLoading)}
      >
        {Array(NUM_LOADING_ITEMS)
          .fill(true)
          .map((_, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: noArrayIndexKey
            <div key={`loading-line-item-${i}}`}>
              <LoadingLineItem narrow={narrow} />

              <Box className={styles.divider}>
                <Divider />
              </Box>
            </div>
          ))}
      </Box>
    );
  }

  if (!children) return null;

  return (
    <Box
      element="ul"
      className={listClassName}
      aria-label={intl.formatMessage(messages.ariaLabelText)}
    >
      {children.map((child, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: refactor required
        <Fragment key={i}>
          {child}
          <Box className={styles.divider}>
            <Divider />
          </Box>
        </Fragment>
      ))}
    </Box>
  );
};
